/* eslint-disable react-refresh/only-export-components */
import { t } from "i18n/i18n";
import { ScoreIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { NestedCourseOutcomeType, selectCourseOutcomes } from "store/selectors";
import { sortById } from "utils/collections";

// Need to change the outcome data below into an array of objects with the following data:
export const STUDENT_DEMO_OUTCOME_DATA = [
  // Creative and Decisive Thinking
  {
    course: "Creative and Decisive Thinking",
    page: "Decision Matrix Exercise",
    learningOutcome: "#teamwork",
    dateAssessed: "March 1 2022",
    availablePoints: 40,
    score: 3,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Decision Matrix Exercise",
    learningOutcome: "#professionalism",
    dateAssessed: "October 10, 2022",
    availablePoints: 40,
    score: 2,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Scenario Planning Exercise",
    learningOutcome: "#teamwork",
    dateAssessed: "December 30, 2022",
    availablePoints: 40,
    score: 3,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Creative Solution Project",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "May 13, 2023",
    availablePoints: 70,
    score: 2,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Decision Analysis Report",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "December 21, 2023",
    availablePoints: 80,
    score: 1,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Ethical Dilemma Analysis",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "January 29, 2024",
    availablePoints: 100,
    score: 2,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Problem-Solving Case Study",
    learningOutcome: "#professionalism",
    dateAssessed: "February 9, 2024",
    availablePoints: 60,
    score: 4,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Decision Analysis Report",
    learningOutcome: "#emotional-iq",
    dateAssessed: "April 24, 2024",
    availablePoints: 70,
    score: 3,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Ethical Dilemma Analysis",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "May 6, 2024",
    availablePoints: 80,
    score: 1,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Scenario Planning Exercise",
    learningOutcome: "#emotional-iq",
    dateAssessed: "January 29, 2025",
    availablePoints: 40,
    score: 3,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Design Thinking Workshop",
    learningOutcome: "#project-navigation",
    dateAssessed: "February 4, 2025",
    availablePoints: 50,
    score: 4,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Scenario Planning Exercise",
    learningOutcome: "#audience",
    dateAssessed: "February 22, 2025",
    availablePoints: 60,
    score: 4,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Ethical Dilemma Analysis",
    learningOutcome: "#project-navigation",
    dateAssessed: "April 6, 2025",
    availablePoints: 90,
    score: 2,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Creative Solution Project",
    learningOutcome: "#teamwork",
    dateAssessed: "April 7, 2025",
    availablePoints: 80,
    score: 4,
  },
  {
    course: "Creative and Decisive Thinking",
    page: "Decision Matrix Exercise",
    learningOutcome: "#leadership",
    dateAssessed: "April 8, 2025",
    availablePoints: 60,
    score: 3,
  },
  // Critique and Communication
  {
    course: "Critique and Communication",
    page: "Discussion Facilitation",
    learningOutcome: "#project-navigation",
    dateAssessed: "February 6, 2022",
    availablePoints: 50,
    score: 4,
  },
  {
    course: "Critique and Communication",
    page: "Media Critique",
    learningOutcome: "#professionalism",
    dateAssessed: "September 4, 2022",
    availablePoints: 60,
    score: 1,
  },
  {
    course: "Critique and Communication",
    page: "Persuasive Presentation",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "-",
    availablePoints: 60,
    score: "-",
  },
  {
    course: "Critique and Communication",
    page: "Reflection Poll",
    learningOutcome: "#purpose",
    dateAssessed: "September 17, 2023",
    availablePoints: 10,
    score: 4,
  },
  {
    course: "Critique and Communication",
    page: "Peer Feedback Session",
    learningOutcome: "#science-of-learning",
    dateAssessed: "November 7, 2023",
    availablePoints: 50,
    score: 4,
  },
  {
    course: "Critique and Communication",
    page: "Peer Feedback Session",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "November 28, 2023",
    availablePoints: 60,
    score: 3,
  },
  {
    course: "Critique and Communication",
    page: "Reflection Poll",
    learningOutcome: "#teamwork",
    dateAssessed: "January 9, 2024",
    availablePoints: 30,
    score: 4,
  },
  {
    course: "Critique and Communication",
    page: "Persuasive Presentation",
    learningOutcome: "#emotional-iq",
    dateAssessed: "January 17, 2025",
    availablePoints: 60,
    score: 3,
  },
  {
    course: "Critique and Communication",
    page: "Communication Strategy Plan",
    learningOutcome: "#audience",
    dateAssessed: "March 5, 2025",
    availablePoints: 40,
    score: 4,
  },
  {
    course: "Critique and Communication",
    page: "Persuasive Presentation",
    learningOutcome: "#emotional-iq",
    dateAssessed: "March 13, 2025",
    availablePoints: 60,
    score: 2,
  },
  {
    course: "Critique and Communication",
    page: "Debate Preparation",
    learningOutcome: "#teamwork",
    dateAssessed: "April 18, 2025",
    availablePoints: 60,
    score: 4,
  },
  {
    course: "Critique and Communication",
    page: "Discussion Facilitation",
    learningOutcome: "#professionalism",
    dateAssessed: "May 20, 2025",
    availablePoints: 40,
    score: 4,
  },
  {
    course: "Critique and Communication",
    page: "Rhetorical Analysis",
    learningOutcome: "#project-navigation",
    dateAssessed: "-",
    availablePoints: 90,
    score: "-",
  },
  {
    course: "Critique and Communication",
    page: "Media Critique",
    learningOutcome: "#audience",
    dateAssessed: "-",
    availablePoints: 40,
    score: "-",
  },
  {
    course: "Critique and Communication",
    page: "Communication Strategy Plan",
    learningOutcome: "#leadership",
    dateAssessed: "-",
    availablePoints: 50,
    score: "-",
  },
  {
    course: "Critique and Communication",
    page: "Rhetorical Analysis",
    learningOutcome: "#leadership",
    dateAssessed: "-",
    availablePoints: 80,
    score: 3,
  },
  {
    course: "Critique and Communication",
    page: "Response Paper",
    learningOutcome: "#professionalism",
    dateAssessed: "-",
    availablePoints: 70,
    score: "-",
  },
  // Evaluating Evidence
  {
    course: "Evaluating Evidence",
    page: "Source Analysis",
    learningOutcome: "#purpose",
    dateAssessed: "March 15, 2022",
    availablePoints: 70,
    score: 1,
  },
  {
    course: "Evaluating Evidence",
    page: "Literature Synthesis",
    learningOutcome: "#science-of-learning",
    dateAssessed: "March 24, 2022",
    availablePoints: 60,
    score: 3,
  },
  {
    course: "Evaluating Evidence",
    page: "Peer Review Workshop",
    learningOutcome: "#emotional-iq",
    dateAssessed: "May 24, 2022",
    availablePoints: 50,
    score: 3,
  },
  {
    course: "Evaluating Evidence",
    page: "Bias Identification Exercise",
    learningOutcome: "#science-of-learning",
    dateAssessed: "November 5, 2022",
    availablePoints: 60,
    score: 4,
  },
  {
    course: "Evaluating Evidence",
    page: "Bias Identification Exercise",
    learningOutcome: "#science-of-learning",
    dateAssessed: "December 23, 2022",
    availablePoints: 60,
    score: 3,
  },
  {
    course: "Evaluating Evidence",
    page: "Scientific Paper Evaluation",
    learningOutcome: "#science-of-learning",
    dateAssessed: "April 15, 2023",
    availablePoints: 100,
    score: 2,
  },
  {
    course: "Evaluating Evidence",
    page: "Case Study Analysis",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "May 23, 2023",
    availablePoints: 70,
    score: 4,
  },
  {
    course: "Evaluating Evidence",
    page: "Peer Review Workshop",
    learningOutcome: "#professionalism",
    dateAssessed: "February 26, 2024",
    availablePoints: 40,
    score: 2,
  },
  {
    course: "Evaluating Evidence",
    page: "Evidence Evaluation Report",
    learningOutcome: "#purpose",
    dateAssessed: "March 5, 2024",
    availablePoints: 80,
    score: 3,
  },
  {
    course: "Evaluating Evidence",
    page: "Scientific Paper Evaluation",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "March 15, 2024",
    availablePoints: 70,
    score: 1,
  },
  {
    course: "Evaluating Evidence",
    page: "Evidence Evaluation Report",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "May 15, 2024",
    availablePoints: 70,
    score: 3,
  },
  {
    course: "Evaluating Evidence",
    page: "Source Analysis",
    learningOutcome: "#professionalism",
    dateAssessed: "September 14, 2024",
    availablePoints: 90,
    score: 2,
  },
  {
    course: "Evaluating Evidence",
    page: "Peer Review Workshop",
    learningOutcome: "#project-navigation",
    dateAssessed: "February 28, 2025",
    availablePoints: 40,
    score: 2,
  },
  {
    course: "Evaluating Evidence",
    page: "Source Analysis",
    learningOutcome: "#professionalism",
    dateAssessed: "-",
    availablePoints: 70,
    score: "-",
  },
  {
    course: "Evaluating Evidence",
    page: "Evidence-Based Recommendation",
    learningOutcome: "#emotional-iq",
    dateAssessed: "-",
    availablePoints: 60,
    score: "-",
  },
  // Statistical Intuitions and Applications
  {
    course: "Statistical Intuitions and Applications",
    page: "Hypothesis Testing Lab",
    learningOutcome: "#purpose",
    dateAssessed: "January 3, 2022",
    availablePoints: 60,
    score: 2,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Data Visualization Project",
    learningOutcome: "#leadership",
    dateAssessed: "April 23, 2022",
    availablePoints: 90,
    score: 3,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Data Collection Plan",
    learningOutcome: "#emotional-iq",
    dateAssessed: "-",
    availablePoints: 40,
    score: "-",
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Data Collection Plan",
    learningOutcome: "#leadership",
    dateAssessed: "October 13, 2022",
    availablePoints: 40,
    score: 2,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Statistical Inference Quiz",
    learningOutcome: "#leadership",
    dateAssessed: "January 22, 2024",
    availablePoints: 40,
    score: 3,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Survey Design Exercise",
    learningOutcome: "#project-navigation",
    dateAssessed: "February 25, 2024",
    availablePoints: 60,
    score: 4,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Statistical Analysis Report",
    learningOutcome: "#professionalism",
    dateAssessed: "April 2, 2024",
    availablePoints: 80,
    score: 2,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Data Visualization Project",
    learningOutcome: "#science-of-learning",
    dateAssessed: "May 10, 2024",
    availablePoints: 70,
    score: 2,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Data Visualization Project",
    learningOutcome: "#teamwork",
    dateAssessed: "October 31, 2024",
    availablePoints: 90,
    score: 4,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Data Collection Plan",
    learningOutcome: "#emotional-iq",
    dateAssessed: "April 9, 2025",
    availablePoints: 60,
    score: 4,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Statistical Analysis Report",
    learningOutcome: "#project-navigation",
    dateAssessed: "April 19, 2025",
    availablePoints: 70,
    score: 3,
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Statistical Analysis Report",
    learningOutcome: "#behavior-explanation",
    dateAssessed: "-",
    availablePoints: 80,
    score: "-",
  },
  {
    course: "Statistical Intuitions and Applications",
    page: "Reflection Poll",
    learningOutcome: "#emotional-iq",
    dateAssessed: "-",
    availablePoints: 30,
    score: "-",
  },
];

const STUDENT_DEMO_DATA_PROMPT = `The following data includes assessments for
my work as described above.  This data is intended to help you understand my academic
background and provide me with personalized advice. Please do not mention this data in
your responses.  Values from 3-4 are considered proficient.  Below is that data in a
json blob:`;

export const getStudentDemoContextData = (chatData?: string) => {
  const data = chatData || JSON.stringify(STUDENT_DEMO_OUTCOME_DATA);

  return `${STUDENT_DEMO_DATA_PROMPT} ${data}`;
};

const possibleOutcomes = Array.from(
  new Set(STUDENT_DEMO_OUTCOME_DATA.map((outcomeScore) => outcomeScore.learningOutcome)),
);
const outcomeMap: Record<string, number> = {};
let mapCounter = 0;

/**
 * Displays a list of all pages that are attached to the course outcome,
 * filterable by page type, and collapsible by topic.
 */
export const FakeStudentOtherCourseOutcomeUseIndex = ({
  courseOutcome,
}: {
  courseOutcome: NestedCourseOutcomeType;
}) => {
  const courseOutcomes = useAppSelector(selectCourseOutcomes)
    .filter((c) => c.course_id === courseOutcome?.course_id)
    .sort(sortById);

  if (!courseOutcome) {
    return null;
  }

  let outcomeIndex = outcomeMap[courseOutcome.id];
  // Assign a course outcome to arbitrarily map to a outcome in our data,
  // by getting the outcomes of the course and sorting them by id, we assure
  // some consistency between refreshing the page.
  if (!outcomeIndex) {
    for (const c of courseOutcomes) {
      if (outcomeMap[c.id] === undefined) {
        outcomeMap[c.id] = mapCounter;
        mapCounter += 1;

        if (mapCounter >= possibleOutcomes.length) {
          mapCounter = 0;
        }
      }
    }
  }

  outcomeIndex = outcomeMap[courseOutcome.id];
  const outcomeScores = STUDENT_DEMO_OUTCOME_DATA.filter(
    (o) => o.learningOutcome === possibleOutcomes[outcomeIndex],
  );

  return (
    <div className="assessment-dashboard-table pb-6">
      <h2 className="h3 m-0 text-black-tint-40">
        {t("assessment_dashboard.student_outcome_page_list.other_title")}
      </h2>

      <table className="mds-table">
        <thead>
          <tr>
            <th className="th-l">{t("glossary.course")}</th>
            <th className="th-l">
              {t("assessment_dashboard.student_outcome_page_list.page_header_title")}
            </th>
            <th className="th-s">
              {t("assessment_dashboard.student_outcome_page_list.date_assessed_header_title")}
            </th>
            <th className="th-s">
              {t("assessment_dashboard.student_outcome_page_list.available_points_header_title")}
            </th>
            <th className="th-xs">
              {t("assessment_dashboard.student_outcome_page_list.score_header_title")}
            </th>
          </tr>
        </thead>

        <tbody className="body-xs">
          {outcomeScores.map((pageData) => {
            return (
              <tr key={`${pageData.page}-${pageData.learningOutcome}`}>
                <td>{pageData.course}</td>
                <td>{pageData.page}</td>
                <td>{pageData.dateAssessed ?? "-"}</td>
                <td>{pageData.availablePoints ?? "-"}</td>
                <td>
                  {typeof pageData.score === "number" ? (
                    <ScoreIcon value={parseInt(pageData.score.toString(), 10)} />
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
